import { WppIconSuccess, WppIconWarning } from '@wppopen/components-library-react'
import { ERROR_MESSAGES } from 'utils/constants'

const { MANDATORY_FIELD } = ERROR_MESSAGES

export const renderInputIcon = (value: string | '' | undefined, errorMessage: string | undefined) => {
  if (!!errorMessage) return undefined

  return !!value ? (
    <WppIconSuccess slot="icon-end" aria-label="Success icon" />
  ) : (
    <WppIconWarning slot="icon-end" aria-label="Warning icon" />
  )
}

export const renderMessage = (
  isFormActive: Boolean,
  inputValue: string | undefined,
  errorMessage: string | undefined,
) => {
  if (!isFormActive) return undefined
  if (errorMessage) return errorMessage
  if (!inputValue) return MANDATORY_FIELD
}

export const renderMessageType = (
  isFormActive: boolean,
  inputValue: string | undefined,
  errorMessage: string | undefined,
) => {
  if (!isFormActive) return undefined
  if (errorMessage) return 'error'
  if (!inputValue) return 'warning'
}
